/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Kpi_Bill_BadgeInputs */



/**
* | output |
* | --- |
* | "Seats, add-ons & AI usage" |
*
* @param {Partner_Org_Kpi_Bill_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_bill_badge = /** @type {((inputs?: Partner_Org_Kpi_Bill_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Bill_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Plätze, Add-ons & KI-Nutzung")
	return /** @type {LocalizedString} */ ("Seats, add-ons & AI usage")
});